import React from 'react';
import Meta from '../components/Meta';

const SponsorUs = () => {
  return (
    <div>

      <Meta title="Sponsorships Software Talks"/>

      <div className="pt-[5.5rem] lg:pt-8">
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full"/>
          </picture>
          <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
              Sponsor Us
            </h1>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <p> If you are interested in collaboration and would like to make your conference a featured conference of the month, we would be happy to do that for you. When sponsoring SoftwareTalks,
                your conference will be shown at the top of the list for the duration of the sponsorship.</p>
              <p>The price is 300 €/month. If you are interested, send us an email <a href="mailto:hello@softwaretalks.io">hello@softwaretalks.io</a></p>
              <p>Sponsorship Schedule:</p>
              <p>
                <b>2026</b> <br/>
                * January: Sold <br/>
                * February: Available <br/>
                * March: Available <br/>
                * April: Available <br/>
                * May: Available <br/>
                * June: Available <br/>
                * July: Available <br/>
                * August: Available <br/>
                * September: Available <br/>
                * October: Available <br/>
                * November: Available <br/>
                * December: Available <br/>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SponsorUs;
